// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608121404/js/" + chunkId + "." + {"44":"7dac182e","225":"b5d143df","481":"d73e5152","486":"c0748e97","770":"426ce4dc"}[chunkId] + ".0.824285443604382.chunk.js";
};